export const routerDocuments = [
    {
        path: '/documents',
        name: 'Documents',
        meta: {
            authRequired: true,
            roleDefault: 'all',
            role: [],
            typeRouterForm: false,
            titleJP: '立ち上げ資料',
            pageNames: [
                {
                    text: 'ダッシュボード',
                    href: '/'
                },
                {
                    text: '立ち上げ資料',
                    active: true
                }
            ]
        },
        component: () => import('@/views/pages/documents')
    }
];
